import { createMuiTheme } from "@material-ui/core/styles";
const theme = createMuiTheme({
  palette: {
    primary: { main: "#13222D" },
    secondary: {
      main: "#FF0000",
      light: "#FFFFFF",
    },
  },
  overrides: {
    MuiIconButton: {
      root: {
        "&:focus": {
          outline: "none",
        },
      },
    },
    MuiButton: {
      root: {
        "&:focus": {
          outline: "none",
        },
      },
    },
  },
});
export default theme;
